require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./prescription-drug-turn-in-program.json") })
        }
      }, "path---prescription-drug-turn-in-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---prescription-drug-turn-in-program!./.cache/json/prescription-drug-turn-in-program.json
// module id = 959
// module chunks = 231608221292675